/**
 * Section label: a lensometer crosshair and a tracked mono caption. Replaces
 * the rounded pill so the page reads as an instrument, not a toy.
 */
export default function Eyebrow({ children, className = '', tone = 'text-primary-blue' }) {
  return (
    <span className={`label inline-flex items-center gap-2.5 ${tone} ${className}`}>
      <svg
        viewBox="0 0 16 16"
        className="size-3.5 shrink-0"
        fill="none"
        stroke="currentColor"
        aria-hidden
      >
        <circle cx="8" cy="8" r="4.5" strokeWidth="1.25" />
        <path d="M8 0v5M8 11v5M0 8h5M11 8h5" strokeWidth="1.25" />
      </svg>
      {children}
    </span>
  );
}
